export default function getGapXLg(value) {
  switch (value) {
    case 0.5:
      return "lg:gap-x-0.5";
    case 1:
      return "lg:gap-x-1";
    case 2:
      return "lg:gap-x-2";
    case 3:
      return "lg:gap-x-3";
    case 4:
      return "lg:gap-x-4";
    case 5:
      return "lg:gap-x-5";
    case 6:
      return "lg:gap-x-6";
    case 7:
      return "lg:gap-x-7";
    case 8:
      return "lg:gap-x-8";
    case 9:
      return "lg:gap-x-9";
    case 10:
      return "lg:gap-x-10";
    case 12:
      return "lg:gap-x-12";
    case 14:
      return "lg:gap-x-14";
    case 16:
      return "lg:gap-x-16";
    case 20:
      return "lg:gap-x-20";
    case 24:
      return "lg:gap-x-24";
    case 28:
      return "lg:gap-x-28";
    case 32:
      return "lg:gap-x-32";
    case 36:
      return "lg:gap-x-36";
    case 40:
      return "lg:gap-x-40";
    case 44:
      return "lg:gap-x-44";
  }
}
